
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MODEL } from "@/module";

@Component({
  components: {},
})
export default class CardMaker extends Vue {
  @Prop({ required: true }) cardType?: MODEL.CardType;
  @Prop({ required: true }) cardId?: string;
  private trim = false;
  private canvas = false;
  private cardImgUrl = "";
  private href = "";
  private snackbar = false;
  private timeout = 2000;

  created() {
    // const staff = this.$route.query.staff;
    // if (staff != null) {
    //   this.forStaff = true;
    // }
  }

  async mounted() {
    this.href = window.location.href;
    fetch("/api/credentials")
      .then((res) => res.json())
      .then((json) => {
        this.cardImgUrl = `${json.url}/${this.cardType?.bird_type}/${this.cardId}.png?${json.sasToken}`;
      });
  }

  get trimClass(): string {
    return this.trim ? "overflowHidden" : "";
  }

  get mobile(): boolean {
    return this.$vuetify.breakpoint.mobile;
  }

  get cardOverlay(): string | undefined {
    return this.cardType?.assets.overlay;
  }

  get zoom(): number {
    if (this.canvas) {
      return 1;
    } else {
      const dispWidth = this.$vuetify.breakpoint.width; // - this.$vuetify.breakpoint.scrollBarWidth;
      const root = this.$refs.root as HTMLElement;
      const [marginTortalm, previewOriginalWidth, maxZoom] = [48, 1920, 0.25];
      return Math.min((dispWidth - marginTortalm) / previewOriginalWidth, maxZoom);
    }
  }

  private cardBGLoaded() {
    this.$nextTick(() => {
      this.trim = true;
    });
  }

  private copyToClipboard(text: string) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("copied!");
        this.snackbar = true;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  private async downloadCardImg() {
    let link = document.createElement("a");
    link.href = this.cardImgUrl;
    link.target = "_blank";
    link.click();
  }
}
